module.exports = __webpack_public_path__ + "img/53.dde558dd.png";